import { FC, InputHTMLAttributes, SelectHTMLAttributes, TextareaHTMLAttributes } from 'react';

export type InputProps = InputHTMLAttributes<HTMLInputElement> & { invalid?: boolean };
export type SelectProps = SelectHTMLAttributes<HTMLSelectElement> & { invalid?: boolean };
export type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement> & { invalid?: boolean };

function controlClass(base: string, invalid: boolean | undefined, className: string | undefined): string {
  return [base, 'ui-control', invalid ? 'ui-control--invalid' : undefined, className].filter(Boolean).join(' ');
}

/** Native elements, one shared control shell. */
const Input: FC<InputProps> = ({ invalid, className, ...rest }) => (
  <input {...rest} className={controlClass('ui-input', invalid, className)} />
);

const Select: FC<SelectProps> = ({ invalid, className, children, ...rest }) => (
  <select {...rest} className={controlClass('ui-select', invalid, className)}>
    {children}
  </select>
);

const Textarea: FC<TextareaProps> = ({ invalid, className, ...rest }) => (
  <textarea {...rest} className={controlClass('ui-textarea', invalid, className)} />
);

export { Input, Select, Textarea };
export default Input;
